import React from "react"
import { TapTag, StyledTaps } from "./globalStyles"

const Taps = ({ children }) => {
  return (
    <div>
      <StyledTaps>
        <TapTag to="/">Home</TapTag>
        <TapTag to="/resume">Resume</TapTag>
        <TapTag to="/about">About</TapTag>
        <TapTag to="/contact">Contact</TapTag>
      </StyledTaps>
    </div>
  )
}
export default Taps
